'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _ifeisIsomorphic = require('ifeis-isomorphic');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PaymentHistoryDialogController = function () {
  function PaymentHistoryDialogController(fFeisService, fAccountService, fEventService, fPaymentsService, fStripe, $state, $mdDialog, $q, account, feis) {
    var _this = this;

    _classCallCheck(this, PaymentHistoryDialogController);

    this._ = {
      fFeisService: fFeisService,
      fAccountService: fAccountService,
      fStripe: fStripe,
      $state: $state,
      $mdDialog: $mdDialog,
      $q: $q
    };

    this.loading = 0;
    this.account = account;
    this.feis = feis;
    this.paymentItems = { totals: {} };
    this._payments = fPaymentsService.forAccount(account.id).forFeis(feis.id);
    this._events = function () {
      return fEventService.for(_this.feis.id);
    };
    this.fetchData();
  }

  _createClass(PaymentHistoryDialogController, [{
    key: 'close',
    value: function close() {
      this._.$mdDialog.cancel();
    }
  }, {
    key: 'fetchData',
    value: function fetchData() {
      var _this2 = this;

      this.loading++;

      this._.fAccountService.getFromPerson(this.account.id).then(function (acct) {
        return acct.paymentsDue().then(function (paymentsDue) {
          _this2.paymentItems.totals.balance = 0;
          paymentsDue.forEach(function (dues) {
            if (dues.feis.id == _this2.feis.id) {
              _this2.paymentItems.totals.balance = dues.balance;
            }
          });
        });
      });
      this._.$q.all([this._payments.debits(), this._payments.credits(), this._.fAccountService.getFromPerson(this.account.id).then(function (acct) {
        return acct.dependents();
      })]).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 3),
            debits = _ref2[0],
            credits = _ref2[1],
            dependents = _ref2[2];

        _this2.paymentItems.debits = debits;
        _this2.paymentItems.credits = credits;
        _this2.paymentItems.totals.credits = credits.map(function (d) {
          return d.amt;
        }).reduce(function (prev, curr) {
          return prev + curr;
        }, 0);

        var matrix = {
          regs: {},
          others: []
        };

        _this2.paymentItems.totals.regDebits = 0;
        _this2.paymentItems.totals.regExcludedDebits = 0;
        _this2.paymentItems.totals.regTotalDebits = 0;

        _this2.paymentItems.debits.forEach(function (debit) {

          if (debit.type == "REG") {
            var pid = debit.person;

            if (!matrix.regs[pid]) {
              matrix.regs[pid] = {};
              if (pid == _this2.account.id) {
                matrix.regs[pid] = _this2.account;
              } else {
                dependents.forEach(function (dep) {
                  if (dep.id == pid) {
                    matrix.regs[pid] = dep;
                  }
                });
              }
              matrix.regs[pid].fees = [];
              matrix.regs[pid].subtotal = 0;
              matrix.regs[pid].excluded_subtotal = 0;
            }

            if (debit.event) {
              // Get event details with stats properties
              _this2._events().one(debit.event, { stats: true }).then(function (result) {
                debit.event = result;
                if (result.exclude_from_max == 1) {
                  matrix.regs[pid].excluded_subtotal += debit.amt;
                  _this2.paymentItems.totals.regExcludedDebits += debit.amt;
                } else {
                  _this2.paymentItems.totals.regDebits += debit.amt;
                }
                matrix.regs[pid].subtotal += debit.amt;

                _this2.calcTotal();
              });
            }

            matrix.regs[pid].fees.push(debit);
          } else {
            matrix.others.push(debit);
          }
        });

        _this2.paymentItems.totals.otherDebits = matrix.others.map(function (d) {
          return d.amt;
        }).reduce(function (prev, curr) {
          return prev + curr;
        }, 0);

        // Currently all 'other fees' are excluded from max
        _this2.paymentItems.totals.regExcludedDebits += _this2.paymentItems.totals.otherDebits;

        _this2.paymentItems.payments = matrix;
        _this2.loading--;
        return matrix;
      });
    }
  }, {
    key: 'calcTotal',
    value: function calcTotal() {
      this.paymentItems.totals.regTotalDebits = this.paymentItems.totals.regDebits;
      if (this.paymentItems.totals.regDebits > this.feis.acct_max) {
        this.paymentItems.totals.regTotalDebits = this.feis.acct_max;
      }
      this.paymentItems.totals.regTotalDebits += this.paymentItems.totals.regExcludedDebits;
    }
  }, {
    key: 'getEventName',
    value: function getEventName(event) {
      return (0, _ifeisIsomorphic.getDescription)(event);
    }
  }]);

  return PaymentHistoryDialogController;
}();

exports.default = angular.module('ifeis.payment-history', ['ngMaterial']).factory('fPaymentHistoryDialog', function ($mdDialog) {
  return function (ev, account, feis) {
    return $mdDialog.show({
      controller: 'PaymentHistoryDialogController',
      controllerAs: 'ctrl',
      template: require('./tpl.html'),
      targetEvent: ev,
      locals: {
        account: account,
        feis: feis
      }
    });
  };
}).controller('PaymentHistoryDialogController', PaymentHistoryDialogController);


//////////////////
// WEBPACK FOOTER
// ./payment-history/index.js
// module id = 212
// module chunks = 0